import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=58257117&"
import script from "./LegalMentions.vue?vue&type=script&lang=js&"
export * from "./LegalMentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports